module.exports = __webpack_public_path__ + "static/img/bubble-film.0ccfbc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/bubble-film.png
// module id = wmIM
// module chunks = 2